// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';

// Utils
import { pluralise } from '../../../../../../../common/utils/stringUtil';
import { getTitle } from '../../../../../../../common/elements/utils/elementPropertyUtils';
import {
    getNotificationBoardTitle,
    getNotificationCommentIdsAsArray,
    getNotificationCommentIsReply,
    getNotificationElementId,
    getNotificationMentionRangesAsArray,
    getNotificationMessage,
} from '../../../../../../../common/notifications/notificationModelUtils';

// Components
import BaseNotificationEntry from './BaseNotificationEntry';
import NotificationUserFigure from './NotificationFigureUser';
import UserNames from './UserNames';
import Icon from '../../../../../../components/icons/Icon';
import NotificationMessage from './NotificationMessage';

const BoardTitle = (props) => {
    const { group, element, notification } = props;

    const groupId = get('id', group);
    const boardId = getNotificationElementId(notification);

    if (groupId === boardId) return null;

    const conjunction = getNotificationCommentIsReply(notification) ? 'in' : 'to';

    const boardTitle = getTitle(element) || getNotificationBoardTitle(notification);

    if (!boardTitle) return <span> {conjunction} a board</span>;

    return (
        <span>
            {' '}
            {conjunction} <span className="board-title">{boardTitle}</span>
        </span>
    );
};

const NotificationEntryComment = (props) => {
    const { actors, notification } = props;

    const isReply = getNotificationCommentIsReply(notification);
    const commentIds = getNotificationCommentIdsAsArray(notification);

    const message = getNotificationMessage(notification);
    const mentionRanges = getNotificationMentionRangesAsArray(notification);
    const showEllipsis = commentIds.length > 1;

    const statement = isReply
        ? 'replied to your comment'
        : `added ${commentIds.length} ${pluralise('comment', commentIds.length)}`;

    return (
        <BaseNotificationEntry
            {...props}
            className="NotificationEntryComment"
            figure={<NotificationUserFigure {...props} icon={<Icon name="notification-comment" />} />}
        >
            <div className="notification-statement">
                <UserNames users={actors} /> {statement} <BoardTitle {...props} />
            </div>
            <NotificationMessage message={message} mentionRanges={mentionRanges} showEllipsis={showEllipsis} />
        </BaseNotificationEntry>
    );
};

BoardTitle.propTypes = NotificationEntryComment.propTypes = {
    element: PropTypes.object,
    group: PropTypes.object,
    actors: PropTypes.array,
    notification: PropTypes.object,
    previousLastCheckedNotifications: PropTypes.number,
};

export default NotificationEntryComment;
